/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Platforms_FcInputs */

const en_fc_cmp_platforms_fc = /** @type {(inputs: Fc_Cmp_Platforms_FcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS, Windows, Linux, FreeBSD`)
};

/**
* | output |
* | --- |
* | "macOS, Windows, Linux, FreeBSD" |
*
* @param {Fc_Cmp_Platforms_FcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_platforms_fc = /** @type {((inputs?: Fc_Cmp_Platforms_FcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Platforms_FcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_platforms_fc(inputs)
});
export { fc_cmp_platforms_fc as "fc.cmp.platforms.fc" }